import isFunction from 'lodash/isFunction';
export function getMountContainer(mountContainer) {
  var container = isFunction(mountContainer) ? mountContainer() : mountContainer;
  return container || document.body;
}